import React from 'react';
import { Container, Typography, Box, Grid } from '@mui/material';
import { DarkModeToggle } from '../DarkModeToggle/DarkModeToggle';
import ProfileSidebar from './ProfileSidebar';
import ProfileEditCard from './ProfileEditCard';
import PersonalizeCard from './PersonalizeCard';
import SubscriptionCard from './SubscriptionCard';
import AccountSettingsCard from './AccountSettingsCard';
import './Profile.scss';

const Profile: React.FC = () => {
  return (
    <Container maxWidth="lg" className="profile-container">
      {/* Header with dark mode toggle */}
      <Box className="profile-header" mb={4}>
        <Box display="flex" justifyContent="space-between" alignItems="flex-start">
          <Box>
            <Typography variant="h4" component="h1" className="profile-title">
              My Profile
            </Typography>
            <Typography variant="subtitle1" color="text.secondary" className="profile-subtitle">
              Manage your account settings and preferences
            </Typography>
          </Box>
          <DarkModeToggle size="large" />
        </Box>
      </Box>

      {/* Main Layout */}
      <Grid container spacing={3} className="profile-layout">
        {/* Sidebar - 30% width on desktop, full width on mobile */}
        <Grid item xs={12} md={4} lg={3}>
          <ProfileSidebar className="fade-in" />
        </Grid>

        {/* Main Content - 70% width on desktop, full width on mobile */}
        <Grid item xs={12} md={8} lg={9}>
          <Box display="flex" flexDirection="column" gap={3}>
            {/* Profile Edit Card */}
            <ProfileEditCard className="slide-up" />
            
            {/* Personalization Card */}
            <PersonalizeCard className="slide-up" />
            
            {/* Subscription Card */}
            <SubscriptionCard className="slide-up" />
            
            {/* Account Settings Card */}
            <AccountSettingsCard className="slide-up" />
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Profile;